export enum ProgramsClassesOrderingEnum {
  Class = 'Class',
  BCRMClassNumber = 'BCRMClassNumber',
  SchoolName = 'SchoolName',
  NumberOfStudents = 'StudentCount',
}
